<template>
  <v-container v-if="band">
    <page-header :title="band.name"/>
    <v-container grid-list-md :class="['pa-0']">
      <v-layout row wrap>
        <v-flex lg6 xs12 d-flex>
          <v-card>
            <v-img v-if="band.logo && !band.logo.includes('undefined')" :src="band.logo" :alt="band.logo" :title="band.name" />
            <v-card-text v-html="band.biography" :class="['meta-description']" />
          </v-card>
        </v-flex>
        <v-flex lg6 xs12 d-flex v-if="band.photo && !band.photo.includes('undefined')">
          <v-card>
            <v-card-text v-if="band.photo">
              <v-img :src="band.photo" :alt="band.photo" :class="['elevation-4']" :title="band.name" />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg6 xs12 d-flex>
          <v-card>
            <v-card-text>
              <band-members :members="band.members.filter(member => member.currentMember)" :title="lang.currentMembers" />
              <band-members :members="band.members.filter(member => !member.currentMember)" :title="lang.previousMembers" />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg6 xs12 d-flex>
          <v-card>
            <v-card-text>
              <v-container :class="['pa-0', 'mt-2']">
                <h3 v-html="lang.discography" :class="['title', 'font-weight-light']" />
                <v-list two-line dense :class="['mt-2']">
                  <template v-for="(album, index) in band.discography">
                    <v-list-tile :key="index" :to="`/albums/${album.id}`" :title="lang.viewMoreInfo(album.title)">
                      <v-list-tile-action>
                        <v-icon>mdi-disk</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="album.title" :class="['wrap']" />
                        <v-list-tile-sub-title v-html="album.year" />
                      </v-list-tile-content>
                      <chevron-right />
                    </v-list-tile>
                    <v-divider inset :key="index + '-divider'" v-if="index < band.discography.length - 1" />
                  </template>
                </v-list>
                <warning :message="lang.recordsNotFound(lang.discography)" v-if="!band.discography.length" />
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'bands-id',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      id: null,
      band: null
    }
  },
  watch: {
    /**
     * route.params.id watcher
     */
    '$route.params.id' () {
      this.onMounted()
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      this.id = this.$route.params.id
      const cache = this.getCachedPage('bands', this.id)
      cache ? this.done(cache) : this.getBandData()
    },
    /**
     * Get the page data from the API
     * @method getBandData
     * @return {void}
     */
    getBandData () {
      const url = this.$root.routes.find(route => route.url.includes('bands/:')).url.replace(':id', this.id)
      this.$http(url)
        .then(response => {
          this.done(response.data.payload)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.band = response
      this.$nextTick(() => {
        this.emitRouteChange()
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.band.name)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/bands-id.vue